import { useState, useEffect, useCallback } from 'react';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import {
  API_GET_NAME_SCHEDULER,
} from '../../../Domain/Redux/Paths';

const useSchedulerName = (schedulerId) => {
  const [nameScheduler, setNameScheduler] = useState(null); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const fetchSchedulerName = useCallback(async () => {
    // Solo hacemos la petición si tenemos un schedulerId válido
    if (!schedulerId) {
      setNameScheduler(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const res = await HttpClient.GET(API_GET_NAME_SCHEDULER, { schedulerId });
      if (res && res.name_scheduler) {
        setNameScheduler(res.name_scheduler);
      } else {
        setNameScheduler(null);
      }
    } catch (err) {
      console.error("Failed to fetch scheduler name:", err);
      setError(err);
      setNameScheduler(null); 
    } finally {
      setLoading(false);
    }
  }, [schedulerId]); 

  useEffect(() => {
    fetchSchedulerName();
  }, [fetchSchedulerName]); 

  return { nameScheduler, loading, error, refetch: fetchSchedulerName };
};

export default useSchedulerName;